import { AbstractControl } from '@angular/forms'

export function noSpacesValidator(control: AbstractControl): { [key: string]: boolean } | null {
  if (control.value && control.value.trim().length === 0) {
    return { 'noSpaces': true }
  }

  return null
}
